import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { of } from 'rxjs';
import { map ,  switchMap } from 'rxjs/operators';

import { toDashedFromCamelCase } from '../../../../../helpers/';
import { BITBUCKET_REPOSITORY_PL } from '../../../../constants/';
import { GetCompleteAction } from '../../../../ngrx/actions/root.action';
import { AppState } from '../../../../ngrx/state/';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import { ESBitbucketRepository } from '../../models/git-repository';
import * as bitbucketRepo from '../bitbucket-repository/bitbucket-repository.actions';
import { getFirstId } from '../bitbucket-company/bitbucket-company.reducer';

@Injectable()
export class BitbucketRepositoryEffects {
  private bitbucketRepoKey = toDashedFromCamelCase(BITBUCKET_REPOSITORY_PL);

  readonly defaultErrorHandler = (action, err) => {
    console.error('effect', action, err);
    return new bitbucketRepo.GetIndexFail();
  };

  @Effect()
  getMany$ = this.data.fetch(bitbucketRepo.GET_INDEX, {
    run: (action, store) =>
      this.api
        .get([this.bitbucketRepoKey], { bitbucketCompany: getFirstId(store) })
        .pipe(
          map(jsonApiToEntityState),
          switchMap((state: ESBitbucketRepository) =>
            of(...[new GetCompleteAction(state), new bitbucketRepo.GetIndexComplete(state)])
          )
        ),
    onError: this.defaultErrorHandler
  });

  constructor(private data: DataPersistence<AppState>, private api: AtlazApiV2Service) {}
}
